import { Fragment } from 'react'
import type {
  CodeSystemPropertyValue,
  TerminologyDisplayInputProps
} from '@healthnz-prm/fhir-engine-renderer/types'

function formatValue(value: CodeSystemPropertyValue): string {
  if (typeof value === 'boolean') return value ? 'Yes' : 'No'
  return String(value)
}

// Properties looked up from a CodeSystem, in the order the questionnaire declared them, with
// one label/value pair per value.
// dt/dd must stay direct children of the dl for the list to be valid.
export default function TerminologyDisplayInput({
  properties
}: TerminologyDisplayInputProps) {
  return (
    <dl className='mb-4 grid grid-cols-[auto_1fr] gap-x-4 gap-y-1'>
      {properties.flatMap(({ code, label, values }) =>
        values.map((value, index) => (
          <Fragment key={`${code}-${index}`}>
            <dt className='text-foreground font-medium'>{label}</dt>
            <dd className='text-foreground'>{formatValue(value)}</dd>
          </Fragment>
        ))
      )}
    </dl>
  )
}
